<template>
  <div id="app" class="profile-page">
    <!-- <token-verification ref="refTokenVerification" /> -->
    <!-- <security-code-verification ref="refSecurityCodeVerification" /> -->

    <foip-statement
      :isFOIPChecked="isFOIPChecked"
      v-show="!isFOIPChecked && isValid"
      @FOIPVisible="isFOIP($event)"
    />

    <div v-show="isFOIPChecked">
      <div style="margin: 10px">
        <!--element which is going to render the Card-->
        <div tabindex="0" class="e-card" id="basic">
          <div class="e-card-title">New User Account Creation</div>
          <div class="e-card-separator"></div>
          <div class="e-card-content">
            <user-address-info
              ref="refUserProfileInfo"
              :userProfileId="userId"
              :userProfilesData="userData"
            />

            <company-info
              ref="refCompanyInfo"
              :user-profile-id="userId"
              :user-profiles-data="userData"
            />

            <contact-info
              ref="refContactInfo"
              :user-profile-id="userId"
              :user-profiles-data="userData"
            />

            <security-questions
              ref="refSecurityQuestions"
              :user-profile-id="userId"
              :user-profiles-data="userData"
            />

            <div class="wrap_address">
              <h4 class="title-color">Web Login Information</h4>
            </div>
            <!-- <div class="e-card-separator"></div> -->
            <web-login-info
              ref="refwebLoginInfo"
              :user-profile-id="userId"
              :user-profiles-data="userData"
              :enableForcePasswordChange="false"
            />
            &nbsp;
            <div class="align-center-bottom">
              <ejs-button
                type="button"
                v-on:click.native="btnComplete"
                cssClass="e-info margin-button"
                >Complete</ejs-button
              >
              <ejs-button v-on:click.native="onCancelButtonClick" cssClass="e-danger margin-button"
                >Cancel</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
// import TokenVerification from '../../auth/components/token-varification.vue';
// import SecurityCodeVerification from '../../auth/components/security-code-verification.vue';
import FoipStatement from "../components/foip-statement.vue";
import UserAddressInfo from "../components/user-address-info.vue";
import ContactInfo from "../components/contact-info.vue";
import CompanyInfo from "../components/company-info.vue";
import SecurityQuestions from "../components/security-questions.vue";
import WebLoginInfo from "../components/web-login-info.vue";

Vue.use(ButtonPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: "NewUser",
  components: {
    // TokenVerification,
    // SecurityCodeVerification,
    FoipStatement,
    ContactInfo,
    CompanyInfo,
    SecurityQuestions,
    UserAddressInfo,
    WebLoginInfo,
  },
  mounted() {},
  computed: {
    isValid() {
      return !!this.$store.getters.confirmedUser;
    },
    userData() {
      return this.$store.getters.confirmedUser;
    },
    userId() {
      return this.$store.getters.confirmedUser ? this.$store.getters.confirmedUser.userId : null;
    },
  },
  data() {
    return {
      isFOIPChecked: false,
    };
  },
  methods: {
    isFOIP(event) {
      this.isFOIPChecked = event;
    },
    onCancelButtonClick() {
      this.$router.push("/");
    },
    btnComplete() {
      // this.$parent.notificationToasts.length = 0;
      const userInfo = this.$refs.refUserProfileInfo;
      const contactInfo = this.$refs.refContactInfo;
      const securityQuestion = this.$refs.refSecurityQuestions;
      const companyInfo = this.$refs.refCompanyInfo;
      const loginInfo = this.$refs.refwebLoginInfo;
      if (
        userInfo.isFirstNameValid
        && userInfo.isLastNameValid
        && userInfo.isAddressValid
        && userInfo.isCityNameValid
        && userInfo.isPostalCodeValid
        && contactInfo.contactDetails[0].isPhoneNumberValid
        && securityQuestion.isSecurityAnswerOne
        && securityQuestion.isSecurityAnswerTwo
        && loginInfo.isPasswordValid
        && loginInfo.isConfirmPassword
        && securityQuestion.isSecurityAnswerThree
        && securityQuestion.ddlSecurityQuestionOne !== null
        && securityQuestion.isConfirmAnswerOne
        && securityQuestion.isConfirmAnswerTwo
        && securityQuestion.isConfirmAnswerThree
        && securityQuestion.ddlSecurityQuestionTwo !== null
        && securityQuestion.ddlSecurityQuestionThree !== null
      ) {
        loginInfo.register();
        userInfo.userProfile(contactInfo.contactDetails[0].phoneNumber);
        contactInfo.userContactInfo();
        securityQuestion.securityQuestions();
        companyInfo.companyData();

        this.$parent.notificationToasts.push({
          title: "Success!",
          content: "You have registered successfully. Please login using username and password.",
          cssClass: "e-toast-success",
          timeOut: 5000,
        });
        this.$router.push("/login");
      } else {
        userInfo.validateUserInfo();
        contactInfo.validateContact();
        securityQuestion.validateSecurityQuestions();
        loginInfo.validatePassword();
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Please enter value in required fields.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>
.e-card-content {
  margin: 0% !important;
}
.wrap_address {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 2px 2px;
  width: 98%;
}
</style>
